<template>
  <div :class="utmSource=='huodong26'?'wrap noWrap':'wrap'">

    <div v-if="utmSource=='huodong1'" class="topBox topBox50"></div>
    <div v-if="utmSource=='huodong2'" class="topBox topBox88"></div>
    <div v-if="utmSource=='huodong3'" class="topBox topBox88"></div>
    <div v-if="utmSource=='huodong4'||utmSource=='huodong4_2'" class="topBox topBox_4"></div>
    <div v-if="utmSource=='huodong5'||utmSource=='huodong5_2'" class="topBox topBox_5"></div>
    <div v-if="utmSource=='huodong6'" class="topBox topBox_6"></div>
    <div v-if="utmSource=='huodong7'" class="topBox topBox_7"></div>
    <div v-if="utmSource=='huodong8'" class="topBox topBox_8"></div>
    <div v-if="utmSource=='huodong9'||utmSource=='huodong10'||utmSource=='huodong11'||utmSource=='huodong12'||utmSource=='huodong13'||utmSource=='huodong14'||utmSource=='huodong15'||utmSource=='huodong16'||utmSource=='huodong17'||utmSource=='huodong18'||utmSource=='huodong19'" class="topBox topBox_9"></div>
    <div v-if="utmSource=='huodong20'||utmSource=='huodong21'||utmSource=='huodong22'" class="topBox topBox_20"></div>
    <div v-if="utmSource=='huodong23'" style="height:16rem" class="topBox topBox_23"></div>
    <img v-if="utmSource=='huodong26'" class="topBox_26" src="/images/pullNew/topBox_26.jpg"/>
    
    
    <div class="g-fixed-bottom">
      <div class="btmBtn" @click="loginPopup=true">立即领取</div>
    </div>

    <!-- 登录 -->
    <van-popup v-model="loginPopup">
      <div class="myPopup">

        <div class="box1">
          <div class="text1">+86</div>
          <input type="number" v-model="params.tel" :maxlength="11" placeholder="手机号" />
        </div>

        <div class="box2">
          <input type="number" ref="yzmInput" v-model="params.yzm" :maxlength="4" placeholder="验证码" />
          <div v-if='second==-1' class="sendBtn" @click="getYzm">获取验证码</div>
          <div v-if='second!=-1' class="sendBtns">（{{second}}）</div>

        </div>

        <div v-if="params.tel.length!=11||params.yzm.length<4" class="btn">立即领取</div>
        <div v-if="params.tel.length==11&&params.yzm.length>=4" class="btns" @click="getYes">立即领取</div>

      </div>
    </van-popup>
    <!-- 登录 -->

  </div>
</template>

<script>
import { Toast } from 'vant';
import pullnewApi from '@/axios/pullnew'
export default {
  name: 'pullNewIndex',
  props: {

  },
  data() {
    return {
      textCopy: 'baozheng87',
      loginPopup: false,
      getYzmBtn: true,
      second: -1,
      utmSource: '',
      params: {
        tel: '',
        yzm: ''
      }
    }
  },
  watch: {

  },
  computed: {
 
  },

  created() {
    let serrchObj = {}
    if(location.search.indexOf('?')!=-1) {
      let searchStr = location.search.split('?')[1]
      let arr = searchStr.split('&')
      arr.map(item=>{
        let key = item.split('=')[0]
        let value = item.split('=')[1]
        serrchObj[key] = value
      })
    }
    if(serrchObj['utm_source']) {
      console.log('serrchObj',serrchObj)
      this.utmSource = serrchObj['utm_source']
      if(this.utmSource == 'huodong6') {
        document.title = "618来了，戳我领88折无门槛打折券"
      }
      zhuge.track('包拯多点推广-曝光',{
        'utmSource': serrchObj['utm_source']
      })
    }
  },
  methods: {
    callback() {},

    getYzm() {
      if (!this.getYzmBtn) {
        return
      }
      if (this.params.tel.length !== 11 || this.params.tel[0] != '1') {
        Toast('请输入正确的手机号');
        return
      }
      this.getYzmBtn = false
      let params = {
        actionName: 'CHANNEL_PULL_NEW',
        mobile: this.params.tel
      }
      pullnewApi.sendSms(params).then((res) => {
        this.getYzmBtn = true
        Toast('发送成功');
        this.second = 60
        let timer = setInterval(() => {
          if (this.second === -1) {
            clearInterval(timer)
            return
          }
          this.second--
        }, 1000)
      }).catch(res => {
        this.getYzmBtn = true
      })

    },

    getYes() {
      let params = {
        mobile: this.params.tel,
        smsVerifyCode: this.params.yzm,
        utmSource: this.utmSource.split('_')[0]
        // utmSource: 'WEIXINONE'
      }
      pullnewApi.receiveCoupon(params).then((res) => {
        this.loginPopup = false
        Toast('领取成功')
        setTimeout(()=>{
          this.$router.push({ name: 'couponList'});
        },1000)
      })

    },


  }
}
</script>

<style scoped lang="scss">
*{
  margin: 0;
  padding: 0;
}
.wrap{
  width: 100%;
  height: 100vh;
  padding-top: 2rem;
  box-sizing: border-box;
  background: linear-gradient(to top, rgba(215, 255, 254, 1), rgba(191, 221, 221, 1));
  .topBox{
    width:100%;
    height: 10rem;
  }
  .topBox50{
    background: url('/images/pullNew/background50.png') no-repeat;
    background-size: 100%;
  }
  .topBox88{
    background: url('/images/pullNew/background88.png') no-repeat;
    background-size: 100%;
  }
  .topBox_4{
    background: url('/images/pullNew/topBox_4.png') no-repeat;
    background-size: 100%;
  }
  .topBox_5{
    background: url('/images/pullNew/topBox_5.png') no-repeat;
    background-size: 100%;
  }
  .topBox_6{
    background: url('/images/pullNew/topBox_6.png') no-repeat;
    background-size: 100%;
  }
  .topBox_7{
    background: url('/images/pullNew/topBox_7.png') no-repeat;
    background-size: 100%;
  }
  .topBox_8{
    background: url('/images/pullNew/topBox_8.png') no-repeat;
    background-size: 100%;
  }
  .topBox_9{
    background: url('/images/pullNew/topBox_9.png') no-repeat;
    background-size: 100%;
  }
  .topBox_20{
    background: url('/images/pullNew/topBox_20.png') no-repeat;
    background-size: 100%;
  }
  .topBox_23{
    background: url('/images/pullNew/topBox_23.png') no-repeat;
    background-size: 100%;
  }
  .topBox_26{
    width: 100%;
    display: block;
  }
  .btmBtn{
    width: 9.15rem;
    height: 1.17rem;
    background: #FF2351;
    border-radius: 0.59rem;
    color: white;
    line-height: 1.17rem;
    font-size: 0.45rem;
    text-align: center;
  }
  
}

.noWrap{
  background: transparent !important;
  padding-top: 0;
}
.van-popup {
  background: transparent;
}
.myPopup{
  width: 626px;
  height: 440px;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  .box1{
    width: 100%;
    box-sizing: border-box;
    padding-top: 60px;
    padding-left: 64px;
    font-size: 30px;
    .text1{
      color: #0A0A0A;
      margin-right: 24px;
      display: inline-block;
      text-align: left;
    }
    &>input{
      display: inline-block;
      text-align: left;
      height: 42px;
      width: 400px;
      border: none;
      outline: none;
    }
  }

  .box2{
    width: 100%;
    box-sizing: border-box;
    padding-left: 68px;
    font-size: 30px;
    margin-top: 40px;
    &>input{
      display: inline-block;
      text-align: left;
      height: 42px;
      width: 340px;
      border: none;
      outline: none;
    }
    .sendBtn{
      display: inline-block;
      text-align: right;
      height: 120px;
      line-height: 120px;
      color: #FF2351;
    }
    .sendBtns {
      display: inline-block;
      text-align: right;
      height: 120px;
      line-height: 120px;
      color: #FF2351;
      margin-left: 70px;
    }

  }

  .btn{
    width: 540px;
    height: 86px;
    border-radius: 86px;
    background-color: rgba(255, 35, 81, .5);
    text-align: center;
    line-height: 86px;
    margin: 50px auto 0;
    color: white;
    font-size: 36px;
  }
  .btns{
    width: 540px;
    height: 86px;
    border-radius: 86px;
    background-color: #FF2351;
    text-align: center;
    line-height: 86px;
    margin: 50px auto 0;
    color: white;
    font-size: 36px;
  }
}

.getSuccess{
  width: 632px;
  height: 584px;
  background: url('/images/pullNew/getSuccess.png') no-repeat;
  background-size: contain;
}
.getError{
  width: 626px;
  height: 578px;
  background: url('/images/pullNew/getError.png') no-repeat;
  background-size: contain;
}
</style>
